module.exports = __webpack_public_path__ + "img/not_message.ad3ea8cc.png";